import '../Services.scss';

import { useEffect, useState } from 'react';

import { Alert } from 'react-bootstrap';
import AppButton from '../../../commons/buttons/AppButton';
import AppContainer from '../../../commons/containers/AppContainer';
import AppLinkButton from '../../../commons/buttons/AppLinkButton';
import AppLoading from '../../../commons/AppLoading';
import HallAppCenterContainer from '../../../commons/containers/HallAppCenterContainer';
import Select from 'react-select';

function AddCategory({ options, nextStep, serviceToEdit, onCreateCategory }) {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (serviceToEdit != null && Object.keys(serviceToEdit).length > 0) {
      const matchedOption = options.find((option) => option.value === serviceToEdit.categoryId);
      if (matchedOption) {
        setSelectedOption(matchedOption);
      }
    }
    setIsLoading(false);
  }, [serviceToEdit, options]);

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption && nextStep) {
      nextStep(selectedOption);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: 50,
      borderColor: state.isFocused ? '#6C2BD9' : '#E6E8EF',
      boxShadow: state.isFocused ? '0 0 0 2px #C4B5FD' : 'none',
      '&:hover': {
        borderColor: '#6C2BD9',
      },
      borderRadius: 12,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9CA3AF',
      fontSize: 15,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#111322',
      fontSize: 15,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      borderRadius: 12,
      boxShadow: '0 4px 12px rgba(16, 24, 40, 0.12)',
      border: '1px solid #E6E8EF',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#6C2BD9'
        : state.isFocused
        ? '#F3E8FF'
        : '#fff',
      color: state.isSelected ? '#fff' : '#111322',
      cursor: 'pointer',
      fontSize: 15,
      '&:active': {
        backgroundColor: '#E9D5FF',
      },
    }),
  };

  if (isLoading) {
    return (
      <HallAppCenterContainer>
        <AppLoading />
      </HallAppCenterContainer>
    );
  }

  return (
    <div className="add-category">
      <AppContainer>
        <Alert variant="info" className="add-category__hint">
          Selecione a categoria relacionada ao serviço. Não encontrou?{' '}
          {onCreateCategory ? (
            <button
              type="button"
              className="add-category__hint-link"
              onClick={onCreateCategory}
            >
              Crie uma nova categoria
            </button>
          ) : (
            <>
              Feche esta janela e vá em <strong>Categorias</strong>.
            </>
          )}
        </Alert>

        <div className="add-category__select">
          <label htmlFor="category-select" className="add-category__label">
            Categoria <span className="required">*</span>
          </label>
          <Select
            inputId="category-select"
            menuPlacement="auto"
            styles={customStyles}
            options={options}
            placeholder="Selecione a categoria"
            onChange={handleChange}
            value={selectedOption}
            noOptionsMessage={() => 'Nenhuma categoria encontrada'}
            aria-label="Selecione a categoria do serviço"
          />
        </div>

        <div style={{marginTop: '30px'}} className="add-category__actions">
          <AppButton
            onClick={handleNext}
            disabled={!selectedOption}
            width="100%"
            name="Próximo"
            size="lg"
          />
        </div>
      </AppContainer>
    </div>
  );
}

export default AddCategory;